import { useLocation } from 'react-router-dom'

export const useCheckoutSlug = () => {
  const location = useLocation()
  const pathname = location.pathname

  return {
    isCheckout: pathname.includes('checkout'),
    isCheckoutSuccess: pathname.includes('checkout/success')
  }
}
